'use strict';

class DataWorker {
	static async initialize () {
		await DataWorker._getWorker();
	}


	static async request (type, data = {}) {
		const id = Math.round(Math.random() * 999999);
		// const time = new Date().getTime();
		// console.log('📟 DataHelper Super Worker: → %s: %s', id, type, data); // eslint-disable-line no-console

		await DataWorker._getWorker();
		DataWorker.worker.postMessage(JSON.stringify([id, type, data]));

		return new Promise((resolve, reject) => {
			DataWorker.handlers = DataWorker.handlers || {};
			DataWorker.handlers[id] = (isError, response) => {
				// console.log('📟 DataHelper Super Worker: ← %s: %o (took %s ms)', id, response, new Date().getTime() - time); // eslint-disable-line no-console

				if(isError) {
					const e = new Error(response.error);
					e.stack = response.stack;
					reject(e);
				} else {
					resolve(response || null);
				}

				delete DataWorker.handlers[id];
			};
		});
	}

	static async _getWorker () {
		if (typeof Worker === 'undefined') {
			throw new Error('Browser doesn\'t support WebWorkers!');
		}
		if (DataWorker.worker && DataWorker.worker instanceof Worker) {
			return DataWorker.worker;
		}

		DataWorker.worker = new Worker('/worker.js');
		if (DataWorker.worker instanceof Worker) {
			DataWorker.worker.addEventListener('message', DataWorker.onWorkerMessage, false);
		}
	}

	static onWorkerMessage (e) {
		try {
			const d = JSON.parse(e.data);

			DataWorker.handlers = DataWorker.handlers || {};
			if(DataWorker.handlers[d[0]]) {
				DataWorker.handlers[d[0]](d[1], d[2]);
			}
		}
		catch(err) {
			// ignore
		}
	}
}

module.exports = DataWorker;
